import numeral from 'numeral'

export const BID_ACTIONS = {
  SET_BIDDING_PRICE: 'SET_BIDDING_PRICE',
  INCREMENT_BID_PRICE: 'INCREMENT_BID_PRICE',
  DECREMENT_BID_PRICE: 'DECREMENT_BID_PRICE',
}

const PRICE_INCREMENT_STEP = 10

function validateBidPrice(price) {
  let newPrice = numeral(price || 0).value() ?? 0
  if (newPrice > 99999) newPrice = newPrice % 100000
  else if (newPrice < 0) newPrice = 0

  const hasError = newPrice === 0
  return { validatedPrice: newPrice, hasError }
}

export const initialState = {
  biddingPrice: 0,
  biddingPriceError: false,
}

export function bidReducer(state, action) {
  const { payload, type } = action
  switch (type) {
    case BID_ACTIONS.SET_BIDDING_PRICE: {
      const price = payload
      const { validatedPrice, hasError } = validateBidPrice(price)

      return {
        ...state,
        biddingPrice: validatedPrice,
        biddingPriceError: hasError,
      }
    }
    case BID_ACTIONS.INCREMENT_BID_PRICE: {
      const { biddingPrice } = state
      const { validatedPrice, hasError } = validateBidPrice(biddingPrice + PRICE_INCREMENT_STEP)

      return {
        ...state,
        biddingPrice: validatedPrice,
        biddingPriceError: hasError,
      }
    }
    case BID_ACTIONS.DECREMENT_BID_PRICE: {
      const { biddingPrice } = state
      const { validatedPrice, hasError } = validateBidPrice(biddingPrice - PRICE_INCREMENT_STEP)

      return {
        ...state,
        biddingPrice: validatedPrice,
        biddingPriceError: hasError,
      }
    }
    default: {
      return {
        ...state,
      }
    }
  }
}
